import { Action } from '@ngrx/store';
import { ISpringResponseBody } from '@app/shared/interfaces/response-interfaces';
import { HistoryData } from '@app/certificates/history/history';

export enum HistoryActionTypes {
    CLEAR_HISTORY = '[History] Clear History',
    ORDERS_RETREIVED = '[History] Retrieved order history',
    ERROR = '[History] Error'
}

export class ActionHistoryClearHistory implements Action {
    readonly type = HistoryActionTypes.CLEAR_HISTORY;
}

export class ActionHistoryOrdersRetreived implements Action {
    readonly type = HistoryActionTypes.ORDERS_RETREIVED;
    constructor(public payload: { orders: HistoryData['orders'] }) { }
}

export class ActionHistoryError implements Action {
    readonly type = HistoryActionTypes.ERROR;
    constructor(public payload: { response?: ISpringResponseBody }) { }
}

export type HistoryActions =
    ActionHistoryOrdersRetreived |
    ActionHistoryClearHistory |
    ActionHistoryError;

export const selectorHistory = state =>
    (state.history || {}) as HistoryData;

export function historyReducer(
    state: HistoryData,
    action: HistoryActions
): HistoryData {
    switch (action.type) {
        case HistoryActionTypes.ORDERS_RETREIVED:
            return { ...state, orders: action.payload.orders };
        case HistoryActionTypes.CLEAR_HISTORY:
            return null;
        default:
            return state;
    }
}
